// extracted by mini-css-extract-plugin
export default {"logged-block":"ServiceDetailTemplate_logged-block__Pwcib","logged-block__link":"ServiceDetailTemplate_logged-block__link__MalVt"};